// User service — profile CRUD, phone/email updates, contact verification
const getUserServiceBaseUrl = () => {
    if (process.env.UMS_BASE_URL) {
        return process.env.UMS_BASE_URL;
    }

    switch (process.env.HOST_ENV) {
    case "PRODUCTION":
        return "https://api.cars24.com/gw/plt/usersvc";
    case "STAGING":
    case "LNOD":
        return "https://c24-user-service-stage.qac24svc.dev";
    case "QA":
    default:
        return "https://c24-user-service-qa.qac24svc.dev";
    }
};

// Auth service — OTP generation/verification
const getAuthServiceBaseUrl = () => {
    if (process.env.BIFROST_AUTH_SERVICE_BASE_URL) {
        return process.env.BIFROST_AUTH_SERVICE_BASE_URL;
    }

    switch (process.env.HOST_ENV) {
    case "PRODUCTION":
        return "https://auth.cars24.com.au";
    case "STAGING":
    case "LNOD":
        return "https://c24-user-service-stage.qac24svc.dev";
    case "QA":
    default:
        return "https://c24-user-service-stage.qac24svc.dev";
    }
};

const parseJsonResponse = async (response) => {
    const payload = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw payload;
    }

    return payload;
};

const getUserProfile = async (token) => {
    const response = await fetch(`${getUserServiceBaseUrl()}/api/v1/user`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    });

    return parseJsonResponse(response);
};

const updateUserProfile = async (token, data) => {
    const response = await fetch(`${getUserServiceBaseUrl()}/api/v1/user`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });

    return parseJsonResponse(response);
};

const generateOtp = async (token, methodId, identifier) => {
    const response = await fetch(`${getAuthServiceBaseUrl()}/api/v1/otp/generate`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            method_id: methodId,
            identifier
        })
    });

    return parseJsonResponse(response);
};

const verifyContact = async (token, updateType, otp) => {
    const response = await fetch(`${getUserServiceBaseUrl()}/api/v1/user/contact/verify`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
            update_type: updateType,
            otp
        })
    });

    return parseJsonResponse(response);
};

const updatePhone = async (token, phone, otp) => {
    const response = await fetch(`${getUserServiceBaseUrl()}/api/v1/user/phone`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ phone, otp })
    });

    return parseJsonResponse(response);
};

const updateEmail = async (token, email, otp) => {
    const response = await fetch(`${getUserServiceBaseUrl()}/api/v1/user/email`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ email, otp })
    });

    return parseJsonResponse(response);
};

export const OTP_METHOD = {
    PHONE_VERIFY: "PHONE_VERIFY",
    EMAIL_VERIFY: "EMAIL_VERIFY",
    UPDATE_PHONE: "UPDATE_PHONE",
    UPDATE_EMAIL: "UPDATE_EMAIL"
};

export default {
    getUserProfile,
    updateUserProfile,
    generateOtp,
    verifyContact,
    updatePhone,
    updateEmail,
    getUserServiceBaseUrl,
    getAuthServiceBaseUrl
};
